<div class="d-flex justify-content-center m-2">
    <div class="card text-white bg-primary mb-3" style="max-width: 30rem;">
      <div class="card-body">
        <h4 class="card-title">{{ 'error_page_not_found' | translate }}</h4>
        <p class="card-text">
          {{ 'error_page_not_found_message' | translate }}            
        </p>
        <button class="btn w-100 btn-warning text-light" (click)="home()"><span class="fa fa-home"></span> {{ 'button_go_home' | translate }}</button>
      </div>
    </div>